import { Component, OnInit, signal, inject } from '@angular/core';
import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { ImageService } from '@app/shared/services/image.service';
import { HelperService } from '@app/shared/services/helper.service';
import { ParagraphComponent } from '@shared/components/text/p/p.component';
import { ImgLoadingCompletedDirective } from '../../../directives/img-loading-completed.directive';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-ranking-info-modal',
  templateUrl: './ranking-info.component.html',
  styleUrls: ['./ranking-info.component.scss'],
  standalone: true,
  imports: [ParagraphComponent, ImgLoadingCompletedDirective, SharedModule],
})
export class RankingInfoComponent implements OnInit {
  private eventManager = inject(EventManager);
  private imageService = inject(ImageService);
  private helper = inject(HelperService);
  logger = inject(LoggerService);

  arrow: string;
  glow: string;
  prize: string;
  ranking: string;
  slot: string;

  imgLoaded = signal(0);

  constructor() {
    this.imageService.imagesLoading$.subscribe((remaining: number) => {
      if (remaining === 0) {
        this.imgLoaded.set(1);
      }
    });
  }

  ngOnInit() {
    this.arrow = this.loadImage('arrow', 'png');
    this.glow = this.loadImage('glow', 'png');
    this.prize = this.loadImage('prize', 'png');
    this.ranking = this.loadImage('ranking', 'png');
    this.slot = this.loadImage('slot', 'png');
  }

  loadImage(imgName: string, extension: string): string {
    const prefix = '/images/home/ranking/info/';
    const path = extension ? `${prefix}${imgName}.${extension}` : `${prefix}${imgName}`;
    return this.helper.getCloudServiceCdnContent(path);
  }

  closeRankingInfo() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.RankingInfo, ModalType.View));
  }
}
